export const TABLE_SIDE_SCROLL_PIXEL_VALUE = 450
